import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Link } from '@/components/Elements/Link/Link';
import { routes } from '@/constants/routes';
import { defaultLocale } from '@/constants/locale';
import styles from './have-an-account-link.module.scss';
import { getRedirectAppParams } from '@/utils/urls';

export const HaveAnAccountLink = ({ signInLink }: { signInLink?: string }) => {
  const { t } = useTranslation();
  const params = useParams();
  const lang = params.lang || defaultLocale;

  // Internal links must carry the /:lang prefix. Without it the router reads
  // the route name as the language and the user is stranded on the landing
  // page loader (PDE-914).
  const search = signInLink ?? getRedirectAppParams();

  return (
    <p
      className={styles.haveAnAccountLink}
      data-testid="already-have-an-account-sign-in"
    >
      {t('common.alreadyHaveAnAccount')}
      <Link
        href={`/${lang}${routes.login}${search}`}
        text={t('common.signIn')}
        className={styles.link}
      />
    </p>
  );
};
